import {configureAnalyticsSink} from '@smartmixin/core/src/utils/Analytics/sink';
import {sendCoreAnalyticsEvent} from './analytics';

/**
 * Send core's product events (favourites, #379) to GA. Called once at
 * startup, from App.tsx.
 */
export const installAnalyticsSink = () => {
  configureAnalyticsSink(sendCoreAnalyticsEvent);
};
